import React from 'react'
import { motion } from 'framer-motion'

import logo from "../../assets/mhc-logo.png";

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' }
  }
}

const FadeInSection = ({ children }) => {
  return (
    <motion.div
      variants={fadeInUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      {children}
    </motion.div>
  )
}

export default function PrivacyPolicy() {
    return (
        <div>

<div className="bg-black h-[68px] sm:h-[78px] md:h-[84px] lg:h-[90px] flex items-center justify-center px-4">
            <img
              src={logo}
              alt="MHC Global"
              className="h-[28px] sm:h-[34px] md:h-[36px] lg:h-[40px] object-contain"
            />
          </div>
            <div className='px-20 max-sm:px-5 py-5 text-3xl font-semibold'>
                <FadeInSection>
                    <h1>Privacy Policy for MHC Global</h1>
                </FadeInSection>
            </div>
            <hr />
            <div className='px-20 max-sm:px-5 py-5 text-2xl font-semibold'>
                <FadeInSection>
                    <h2>Privacy Policy</h2>
                </FadeInSection>
            </div>
            <div className='py-3 px-20 max-sm:px-5 text-lg text-justify'>
                <FadeInSection>
                    <p>
                        Thank you for visiting MHC Global Website and reviewing our privacy policy. The policy is simple: We collect no personal information about you unless you choose to provide that information to us. We strictly do not share, give, transfer or sell any of your personal information to any third party.
                    </p>
                </FadeInSection>
            </div>
            <div className='py-3 px-20 max-sm:px-5 text-lg text-justify'>
                <FadeInSection>
                    <p>
                        In case, if you want to know about how we record non-personal information when you visit our site or how we use the information that you voluntarily submit, read further:
                    </p>
                </FadeInSection>
            </div>
            <div className='px-20 max-sm:px-5 py-5 text-2xl font-semibold'>
                <FadeInSection>
                    <p>
                        Non-Personal Information that we Record
                    </p>
                </FadeInSection>
            </div>
            <div className='py-3 px-20 max-sm:px-5 text-lg text-justify'>
                <FadeInSection>
                    <p>
                        On visiting our website, if you just browse through read or download information, our site’s operating system will automatically record some general information about your visit.
                    </p>
                </FadeInSection>
            </div>
            <div className='px-20 max-sm:px-5 py-5 text-2xl font-semibold'>
                <FadeInSection>
                    <p>
                        During your visit, the web operating system will record:
                    </p>
                </FadeInSection>
            </div>
            <div className="py-3 px-20 max-sm:px-5 text-lg text-justify">
                <ul className='space-y-3'>
                    <FadeInSection>
                        <div className='flex'>
                            <span className='text-xl font-bold mr-2'>&#8226;</span><li className=''>
                                The Internet domain for your internet service, such as “xyz.net” or “xyz.com”  if you are using private internet access account or if you connect from college or university domain.
                            </li>
                        </div>
                    </FadeInSection>
                    <FadeInSection>
                        <div className='flex'>
                            <span className='text-xl font-bold mr-2'>&#8226;</span><li className=''>
                                The type of browser (such as “Internet explorer version x” or “netscape version x”) that you are using.
                            </li>
                        </div>
                    </FadeInSection>
                    <FadeInSection>
                        <div className='flex'>
                            <span className='text-xl font-bold mr-2'>&#8226;</span><li className=''>
                                The operating system that you are currently using (such as Windows, Unix, or Macintosh)
                            </li>
                        </div>
                    </FadeInSection>
                    <FadeInSection>
                        <div className='flex'>
                            <span className='text-xl font-bold mr-2'>&#8226;</span><li className=''>
                                The time and date that you visit our site, and the webpages that you visit on our site.
                            </li>
                        </div>
                    </FadeInSection>
                    <FadeInSection>
                        <div className='flex'>
                            <span className='text-xl font-bold mr-2'>&#8226;</span><li className=''>
                                The address of the previous website you were visiting, in case you linked us from another website.
                            </li>
                        </div>
                    </FadeInSection>
                </ul>
            </div>
            <div className='py-3 px-20 max-sm:px-5 text-lg text-justify'>
                <FadeInSection>
                    <p>
                        This purpose of recording this information is for statistical analysis, to help make our site more useful to visitors. Individual information is not recorded by this tracking system.
                    </p>
                </FadeInSection>
            </div>
            <div className='px-20 max-sm:px-5 py-5 text-2xl font-semibold'>
                <FadeInSection>
                    <p>
                        Cookies
                    </p>
                </FadeInSection>
            </div>
            <div className='py-3 px-20 max-sm:px-5 text-lg text-justify'>
                <FadeInSection>
                    <p>
                        We use "cookies" on certain MHC Global pages to help you use our website interactively. If you are wondering what is a cookie?. It is a small file that a website transfers to your computer’s hard disk, usually to keep track of you while you are connected to that site.
                    </p>
                </FadeInSection>
            </div>
            <div className='py-3 px-20 max-sm:px-5 text-lg text-justify'>
                <FadeInSection>
                    <p>
                        Cookies of MHC Global web pages do not collect information about you, but just the "browser" session. The webpages dynamic features becomes easier for you to use because of the cookie, it prevents the cycle of having to provide the same information again as you browse from one page to another.
                    </p>
                </FadeInSection>
            </div>
            <div className='py-3 px-20 max-sm:px-5 text-lg text-justify'>
                <FadeInSection>
                    <p>
                        Remember in order to protect your privacy, be sure to close your browser entirely after you have finished conducting your business with a website that uses cookies. In case you are concerned about the potential misuse of information gathered by cookies placed in your system, set your browser to prompt you before it accepts a cookie. Almost all internet browsers have settings that help you identify cookies.
                    </p>
                </FadeInSection>
            </div>
            <div className='py-3 px-20 max-sm:px-5 text-lg text-justify'>
                <FadeInSection>
                    <p>
                        When you send us an email, the message usually contains your return email address. Email is not necessarily secure against interception. If you include personally – identifying information in your email because you want to address issues specific to your situation, we may use that information in responding to your request. It is important you send only information necessary to help us process your request.
                    </p>
                </FadeInSection>
            </div>
            <div className='px-20 max-sm:px-5 py-5 text-2xl font-semibold'>
                <FadeInSection>
                    <p>
                        Information collected from Interactive Forms
                    </p>
                </FadeInSection>
            </div>
            <div className='py-3 px-20 max-sm:px-5 text-lg text-justify'>
                <FadeInSection>
                    <p>
                        Some of our web pages have interactive forms that allow you to voluntarily submit personal information (such as your e-mail address, name, or organization). This happens when you are registering for online counseling, seminars, various tests, quizzes, workshops or training sessions offered by MHC Global, downloading admission forms from MHC Global. In those cases, all submitted information is used only for the purposes for which it is intended and is not made available to any third party.
                    </p>
                </FadeInSection>
            </div>
            <div className='py-3 px-20 max-sm:px-5 text-lg text-justify'>
                <FadeInSection>
                    <p>
                        When you voluntarily send us electronic mail, we will keep a record of this information so that we can respond to you. We only collect information from you when you register on our site or fill out a form. Also, when filling out a form on our site, you may be asked to enter your: name, e-mail address or phone number. You may, however, visit our site anonymously. In case you have submitted your personal information and contact details, we reserve the rights to Call, SMS, Email or WhatsApp about our products and offers, even if your number has DND activated on it.
                    </p>
                </FadeInSection>
            </div>
            <div className='px-20 max-sm:px-5 py-5 text-2xl font-semibold'>
                <FadeInSection>
                    <p>
                        Links to Other Sites
                    </p>
                </FadeInSection>
            </div>
            <div className='py-3 px-20 max-sm:px-5 text-lg text-justify'>
                <FadeInSection>
                    <p>
                        Our policy mentioned above discloses the privacy practices for MHC Global website. However, MHC Global provides links to other websites. When you leave MHC Global website, you will be going to sites that are beyond our control. These websites may send their own cookies to users, collect data or solicit personal information. The privacy policies and procedures described here for MHC Global do not apply to any other external links. It is advisable to read the privacy policies of any site you link from ours, especially where you share any personal information. Be informed. The best person qualified for your privacy is you.
                    </p>
                </FadeInSection>
            </div>
        </div>
    )
}
